module.exports = __webpack_public_path__ + "3ff0e4df9a7cba1556edb422e0ef6519.jpg";